<template>
  <b-form-group
    label="Sayısal Değer 1"
    label-for="int_value_1"
  >
    <cleave
      id="limits"
      v-model="dataItem.int_value_1"
      class="form-control"
      :raw="true"
      :options="options.limit"
      placeholder="Sayısal Değer 1"
    />
  </b-form-group>
</template>

<script>
import { localize } from 'vee-validate'
import Cleave from 'vue-cleave-component'

import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ParamsNumberValue1',
  components: {
    BFormGroup,
    Cleave,
  },
  data() {
    return {
      required,
      options: {
        limit: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['params/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
